/**
 * @generated SignedSource<<75695f3ffc9f48047b62dc69f3e57a8d>>
 * @relayHash 75ba97e12aabd0b01457d730b2d08e64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e

import type { ConcreteRequest } from 'relay-runtime';
export type useStudioPermissionsQuery$variables = {
  dontRequirePrincipalsInSite?: ReadonlyArray<boolean | null> | null;
  permissionIds?: ReadonlyArray<string | null> | null;
  principalIds?: ReadonlyArray<string | null> | null;
  resourceIds?: ReadonlyArray<string | null> | null;
};
export type useStudioPermissionsQuery$data = {
  readonly bulkPermitted: ReadonlyArray<{
    readonly permissionId: string | null;
    readonly permitted: boolean | null;
  } | null> | null;
};
export type useStudioPermissionsQuery = {
  response: useStudioPermissionsQuery$data;
  variables: useStudioPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dontRequirePrincipalsInSite"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissionIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "principalIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceIds"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "dontRequirePrincipalsInSite",
        "variableName": "dontRequirePrincipalsInSite"
      },
      {
        "kind": "Variable",
        "name": "permissionIds",
        "variableName": "permissionIds"
      },
      {
        "kind": "Variable",
        "name": "principalIds",
        "variableName": "principalIds"
      },
      {
        "kind": "Variable",
        "name": "resourceIds",
        "variableName": "resourceIds"
      }
    ],
    "concreteType": "BulkPermittedResponse",
    "kind": "LinkedField",
    "name": "bulkPermitted",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "permissionId"
      },
      {
        "kind": "ScalarField",
        "name": "permitted"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useStudioPermissionsQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useStudioPermissionsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "75ba97e12aabd0b01457d730b2d08e64",
    "id": "de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e",
    "metadata": {},
    "name": "useStudioPermissionsQuery",
    "operationKind": "query",
    "text": "query useStudioPermissionsQuery($principalIds:[String],$resourceIds:[String],$permissionIds:[String],$dontRequirePrincipalsInSite:[Boolean]){bulkPermitted(principalIds:$principalIds,resourceIds:$resourceIds,permissionIds:$permissionIds,dontRequirePrincipalsInSite:$dontRequirePrincipalsInSite){permissionId,permitted}}"
  }
};
})();

(node as any).hash = "b0e4a1240e10b4a1d2d14d3f9cc8b8e3";

export default node;
